import { NavigateBeforeRounded } from '@mui/icons-material'
import { Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import useScreenWidth from '../../hooks/useScreenWidth'

type ButtonBackProps = {
  goBack?: boolean
  customFunction?: any
  dataName?: string
  async?: boolean
  customText?: string
}

const ButtonBack = ({ customFunction, goBack = true, dataName, async = true, customText }: ButtonBackProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()
  const location = useLocation()

  let isAdmin = location.pathname.includes('admin') || location.pathname === '/escritorio'

  const handleClick = () => {
    if (goBack) navigate(-1)
    if (customFunction !== undefined && !async) customFunction()
    if (customFunction !== undefined && async) dispatch(customFunction)
  }

  return (
    <Box mt={isAdmin ? (isMobile ? 10 : 7) : 2} mb={isAdmin ? (isMobile ? 2 : 6) : 2}>
      <Button
        data-goback={dataName}
        variant="text"
        color={isAdmin ? 'secondary' : 'primary'}
        startIcon={<NavigateBeforeRounded />}
        onClick={handleClick}
      >
        {customText ? `${customText}` : `${t('back')}`}
      </Button>
    </Box>
  )
}

export default ButtonBack
